import { useQuery } from '@tanstack/react-query'
import { Outlet, useParams } from 'react-router-dom'
import { getUserAccessInfo } from '../lib/api/Subscription-Service'
import PaymentStatusModals from '../components/Payment/PaymentStatusModals'

const SubscriptionLayout = () => {
  const { moduleId } = useParams()
  const isLoggedIn = localStorage.getItem('access_token')
  const { data: accessInfo } = useQuery({
    queryKey: ['get-user-access-info', moduleId],
    queryFn: () => getUserAccessInfo(),
    enabled: !!moduleId && !!isLoggedIn,
  })

  const hasAccess = isLoggedIn
    ? {
        hasPro: accessInfo?.data?.hasPro ?? false,
        hasProPlus: accessInfo?.data?.hasProPlus ?? false,
      }
    : null

  return (
    <div className="w-full h-full bg-[#F4F4F7]">
      <div className="p-6 h-full lg:px-10 max-w-[1440px] mx-auto">
        <Outlet context={{ hasAccess }} />
      </div>
      <PaymentStatusModals />
    </div>
  )
}

export default SubscriptionLayout
